import { metaverse } from "data/metaverse";
import { BigNumber } from "ethers";

export function percent(all: number, piece: number): number {
  return (piece / all) * 100;
}

// Create our number formatter.
export const formatter = (symbol: string) =>
  new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: symbol,
    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  });

export const formatEther = (value: BigNumber): number =>
  value.div(BigNumber.from(10).pow(metaverse.decimals)).toNumber();
